<template>
  <div>
    <div>
      <div class="item">
        <span class="title">名称</span>
        <div>
          <el-input v-model="name" style="width:150px" placeholder="请输入投放规则" />
        </div>
      </div>
      <div class="item">
        <span class="title">图片和视频拒审比例</span>
        <div>
          <el-input v-model="material_reject_examine_proportion" oninput="this.value = this.value && parseInt(this.value);this.value>100 && (this.value = 100)" style="width:150px" type="number" placeholder="请输入拒审比例" />
        </div>
      </div>
      <div class="item">
        <span class="title">文本拒审比例 </span>
        <div>
          <el-input v-model="text_reject_examine_proportion" oninput="this.value = this.value && parseInt(this.value);this.value>100 && (this.value = 100)" style="width:150px" type="number" placeholder="请输入拒审比例" />
        </div>
      </div>
      <div class="item">
        <span class="title">原生页拒审比例 </span>
        <div>
          <el-input v-model="url_reject_examine_proportion " oninput="this.value = this.value && parseInt(this.value);this.value>100 && (this.value = 100)" style="width:150px" type="number" placeholder="请输入拒审比例" />
        </div>
      </div>
      <div class="item">
        <span class="title">拒审组件更新重审 </span>
        <div>
          <el-radio-group v-model="is_fail_correction">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item">
        <span class="title">关键字</span>
        <div style="flex:1">
          <el-tag
            v-for="tag in keyWordsObj"
            :key="tag"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            v-if="inputVisible"
            ref="saveTagInput"
            v-model="inputValue"
            class="input-new-tag"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          />
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新建关键词</el-button>
        </div>
      </div>
    </div>
    <div style="text-align: end; margin-top:20px">
      <el-button class="" type="primary" @click="determine">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {

        }
      }
    }
  },
  data() {
    return {
      type: null,
      name: null,
      inputVisible: false,
      inputValue: '', // 输入关键字
      keyWordsObj: [],
      url_reject_examine_proportion: null,
      text_reject_examine_proportion: null,
      material_reject_examine_proportion: null,
      is_fail_correction: 0
    }
  },
  created() {
    this.init()
  },
  mounted() {
  },
  methods: {
    handleClose(tag) {
      this.keyWordsObj.splice(this.keyWordsObj.indexOf(tag), 1)
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      const inputValue = this.inputValue
      if (inputValue) {
        this.keyWordsObj.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    // 确定
    determine() {
      if (this.judgmentParameters()) {
        const parameter = {
          name: this.name,
          key_words: this.keyWordsObj,
          material_reject_examine_proportion: this.material_reject_examine_proportion,
          id: this.drawerItem.id ? this.drawerItem.id : null,
          text_reject_examine_proportion: this.text_reject_examine_proportion,
          url_reject_examine_proportion: this.url_reject_examine_proportion,
          is_fail_correction: this.is_fail_correction
        }
        this.$emit('determine', parameter)
      }
    },

    // 判断参数
    judgmentParameters() {
      let text = null
      if (!this.name) {
        text = '请填写投放规则'
      } else if (!this.keyWordsObj.length) {
        text = '请添加关键字'
      } else if (!this.material_reject_examine_proportion) {
        text = '请添加图片与视频拒审比例'
      } else if (!this.text_reject_examine_proportion) {
        text = '请添加文本拒审比例'
      } else if (!this.url_reject_examine_proportion) {
        text = '请添加原生页拒审比例'
      }

      text && this.$message({
        message: text,
        type: 'warning'
      })

      return !text
    },

    // 初始化
    init() {
      console.log(this.drawerItem, 'this.drawerItem')
      // 名称
      this.name = this.drawerItem.name ? this.drawerItem.name : null
      // this.type = this.drawerItem.type ? String(this.drawerItem.type) : null
      // 关键字
      this.keyWordsObj = this.drawerItem.key_words && this.drawerItem.key_words.length ? this.drawerItem.key_words : []
      // 拒审比例
      this.material_reject_examine_proportion = this.drawerItem.material_reject_examine_proportion ? this.drawerItem.material_reject_examine_proportion : null
      this.text_reject_examine_proportion = this.drawerItem.text_reject_examine_proportion ? this.drawerItem.text_reject_examine_proportion : null
      this.url_reject_examine_proportion = this.drawerItem.url_reject_examine_proportion ? this.drawerItem.url_reject_examine_proportion : null
      this.is_fail_correction = this.drawerItem.is_fail_correction ? this.drawerItem.is_fail_correction : 0
    },
    handleParams(value) {
      const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/img
      this.adverIds = value.replace(str, ',')
      const str1 = /(,){1,}/img
      this.adverIds = this.adverIds.replace(str1, ',')
    }
  }
}
</script>

<style scoped>
.item{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.item .title{
  width: 200px;
}
.item .title1{
  width: 100px;
}

.button-new-tag {
  margin: 10px 10px 0 0;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin: 10px 10px 0 10px;
  vertical-align: bottom;
}
</style>
